
import Paimon from "@/state/PaimonMoe";
import { defineComponent } from "vue";
export default defineComponent({
  emits: ["exit"],
  data() {
    return {
      settings: {
        infinitePrimos: this.$store.state.settings.infinitePrimos,
        rollOnly: "" + (this.$store.state.settings.rollOnly ?? ""),
        winGuarantee: "" + (this.$store.state.settings.winGuarantee ?? ""),
        unlimitedHistoryScroll:
          this.$store.state.settings.unlimitedHistoryScroll,
        showBannerPity: this.$store.state.settings.showBannerPity,
        everythingBanner: this.$store.state.settings.everythingBanner,
      },
      paimon: Paimon.export(),
    };
  },
  computed: {
    paimonExportJson(): string {
      return `data:application/json;charset=utf-8,${encodeURIComponent(
        this.paimon
      )}`;
    },
  },
  methods: {
    exit(): void {
      const settings = {
        infinitePrimos: this.settings.infinitePrimos,
        rollOnly: parseInt(this.settings.rollOnly || "0") || null,
        winGuarantee: !!(this.settings.winGuarantee || false) || null,
        unlimitedHistoryScroll: this.settings.unlimitedHistoryScroll,
        showBannerPity: this.settings.showBannerPity,
        everythingBanner: this.settings.everythingBanner,
      };
      this.$store.commit("updateSettings", settings);
      this.$emit("exit");
    },
  },
});
